import type { CellRendererItem } from "../../data-grid/cell-renderer-item";
import type { GridRendererProvider } from "../../data-grid/grid-renderer-provider.interface";
import { HeaderRendererItem } from "../../data-grid/header-renderer-item";
import { ColumnTypeHeaderComponent } from "./column-type-header.component";

export class ColumnTypeRendererProvider implements GridRendererProvider {
  private renderer = new HeaderRendererItem(ColumnTypeHeaderComponent);

  // null defers to TransformerGridRendererService's DefaultGridRendererProvider fallback - this
  // provider only customizes the column header, not cell or row-number-header rendering.
  getCellRenderer(_colId: string): CellRendererItem | null {
    return null;
  }

  public getRowNumberHeaderRenderer(): HeaderRendererItem | null {
    return null;
  }

  getHeaderRenderer(_colId: string): HeaderRendererItem {
    return this.renderer;
  }

  // Taller than the default 50px: ColumnTypeHeaderComponent stacks a name label, a type select,
  // and an optional date-format control.
  getHeaderHeight(): number {
    return 104;
  }
}
